import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import VizsgaFeladatsorTableDto from '../dto/VizsgaFeladatsorTableDto';

class VizsgaFeladatsorTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'vizsgafeladatsorTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<VizsgaFeladatsorTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, VizsgaFeladatsorTableDto)))
				.catch(reject);
		});
	}
}

export default new VizsgaFeladatsorTableService();
